module.exports = __webpack_public_path__ + "img/hangm.0f5611a7.png";